/**
 * Created by valentin on 29/06/2017.
 */
import React from 'react'
import { patientsDatabase } from '../../../index'
import PanelWithContent from '../../common/PanelWithContent/PanelWithContent'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

export default class PatientInsertion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      redirect: undefined,
      patient: undefined
    }
    this.renderContent = this.renderContent.bind(this)
  }

  savePanelData (data, key) {
    patientsDatabase.push(data).then(() => {
      this.setState({
        patient: data,
        redirect: true
      })
    })
  }

  renderContent () {
    if (this.props.configuration) {
      return this.props.configuration['patientInsertion'].map(element => {
        return <PanelWithContent
          extraFieldContent={element.extraFieldContent}
          saveData={this.savePanelData.bind(this)}
          key={element.key}
          dataKey={element.key}
          title={element.title}
          fields={element.fields}
          extraFieldEnabled={element['isExtraFieldEnabled']} />
      })
    }
  }
  render () {
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: `/patients/${this.state.patient['patientNumber']}`, state: {referrer: this.props.match.url}
      }} />
    }
    return <div className='container-fluid'>
      {this.props.configuration
        ? <div>
          {this.renderContent()}
        </div>
        : null
      }
    </div>
  }
}

PatientInsertion.propTypes = {
  configuration: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/PatientInsertion/PatientInsertion.js